<template>
  <div class="input-group">
    <InputError
      v-for="(propName, index) in propNames"
      :key="index"
      :errors="errors"
      :prop-name="propName"
    ></InputError>
    <slot></slot>
  </div>
</template>

<script>
import InputError from "./InputError";

export default {
  name: "InputGroup",
  components: { InputError },
  props: {
    errors: {
      type: Object,
      default: function () {
        return {};
      },
    },
    propNames: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
